import script from "./colthing.vue?vue&type=script&setup=true&lang=js"
export * from "./colthing.vue?vue&type=script&setup=true&lang=js"

import "./colthing.vue?vue&type=style&index=0&id=ded5ba0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ded5ba0c"]])

export default __exports__